module.exports = __webpack_public_path__ + "img/JgIndex2.a92f98c4.png";